"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PTFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_190)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_190`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.16003 0.000244141H33.84V23.9998H-2.16003V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.6663 0.000244141V23.9998H-2.16003V0.000244141H11.6663Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.6663 16.5C14.1516 16.5 16.1663 14.4853 16.1663 12C16.1663 9.51472 14.1516 7.5 11.6663 7.5C9.18104 7.5 7.16632 9.51472 7.16632 12C7.16632 14.4853 9.18104 16.5 11.6663 16.5Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.13483 9.75V12.5626C9.13483 13.9605 10.2681 15.0938 11.6661 15.0938C13.064 15.0938 14.1973 13.9605 14.1973 12.5626V9.75H9.13483Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.6661 13.4063C11.2008 13.4063 10.8223 13.0278 10.8223 12.5625V11.4375H12.5099V12.5625C12.5098 13.0277 12.1313 13.4063 11.6661 13.4063Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_190`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PTFlag };
